import {
    call,
    put,
    takeLatest,
} from 'redux-saga/effects';

// constants for endpoints
import {
    ACCOUNT
} from "../../../components/global/Server/endpoints";

// constants for actions
import {
    GET_USER_SETTING,
    SAVE_USER_SETTING
} from "../../constants/account";

// secondary actions
import {
    storeTableSetting,
} from "../../actions/account";
import {
    clearStatus,
  showErrorMessage
} from "../../actions/global";
import {SERVER_FAILED_ERROR_MESSAGE} from "../../../pages/Dashboard/constants";
import AuthUtil from "../../AuthUtil";


function* saveUserSetting(action) {
    yield call(clearStatus)
    try {
        const request = {
            userId: action.setting.userId,
            pageTitle: action.setting.pageTitle,
            tableSetting: action.setting.tableSetting,
            defaultTable: action.setting.defaultTable,
            filterSetting: action.setting.filterSetting,
            changeFilters: action.setting.changeFilters,
        };
        const response = yield call(() => AuthUtil.postRequest(ACCOUNT.SAVE_USER_SETTING, request));
        if (response.status === 200) {
            yield put(storeTableSetting(response.data))
        }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}


function* getTableSetting(action) {
    yield call(clearStatus)
    try {
        const request = {
            userId: action.userId
        };
        const response = yield call(() => AuthUtil.postRequest(ACCOUNT.GET_USER_SETTING, request));
        if (response.status === 200) {
            yield put(storeTableSetting(response.data))
        }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}



export default function* accountSagas() {
    yield takeLatest(SAVE_USER_SETTING, saveUserSetting);
    yield takeLatest(GET_USER_SETTING, getTableSetting);
}
